module.exports = __webpack_public_path__ + "img/64800.dea0b4a7.jpg";